import Backend from "./Backend";
import {ReadCompanyDto} from "../model/company/ReadCompanyDto";
import {AddCompanyDto} from "../model/company/AddCompanyDto";
import {BankAccountCode} from "../model/BankAccountCode";
import {CompanyRuleDto} from "../model/company/CompanyRuleDto";
import {AccountCodeDto} from "../model/AccountCodeDto";
import {GetCompanyInfoDto, GetCompanySettingsDto} from "../model/company/GetCompanySettingsDto";
import {SaveCompanySettingsDto} from "../model/company/SaveCompanySettingsDto";
import {ResultOrErrorDto} from "../model/ResultOrErrorDto";

class CompanyApi {
    public fetchCompanies(): Promise<ReadCompanyDto[]> {
        return Backend.get('/api/v1/company');
    }

    public addCompany(dto: AddCompanyDto): Promise<ReadCompanyDto> {
        return Backend.post('/api/v1/company', dto);
    }

    public deleteCompany(id: string): Promise<void> {
        return Backend.delete('/api/v1/company/' + id);
    }

    public fetchBankAccountCodes(selectedCompanyId: string): Promise<BankAccountCode[]> {
        return Backend.get(`/api/v1/company/${selectedCompanyId}/account/bank`)
    }

    public fetchAccountCodes(selectedCompanyId: string): Promise<AccountCodeDto[]> {
        return Backend.get(`/api/v1/company/${selectedCompanyId}/account/all`)
    }

    public fetchRules(selectedCompanyId: string): Promise<CompanyRuleDto[]> {
        return Backend.get(`/api/v1/company/${selectedCompanyId}/rule`)
    }

    public saveRules(selectedCompanyId: string, rules: CompanyRuleDto[]): Promise<void> {
        return Backend.post(`/api/v1/company/${selectedCompanyId}/rule`, rules)
    }

    public fetchSettings(companyId: string): Promise<GetCompanySettingsDto> {
        return Backend.get(`/api/v1/company/${companyId}/settings`)
    }

    public saveSettings(companyId: string, settings: SaveCompanySettingsDto): Promise<GetCompanySettingsDto> {
        return Backend.post(`/api/v1/company/${companyId}/settings`, settings)
    }

    public fetchInfo(companyId: string): Promise<GetCompanyInfoDto> {
        return Backend.get(`/api/v1/company/${companyId}/info`)
    }

    public getDriveUrl(companyId: string): Promise<ResultOrErrorDto<string>> {
        return Backend.get(`/api/v1/company/${companyId}/drive_url`)
    }
}

export const companyApi = new CompanyApi();